// extracted by css-extract-rspack-plugin
export default {"navigator":"Navi__navigator--rp5hH","body":"Navi__body--kLKki","item":"Navi__item--lsmym"};